export default __webpack_public_path__ + "static/media/product-tour7.87de11ae.svg";